  import React from "react";
//import { Route, Redirect } from "react-router-dom";
  import { Route } from "react-router-dom";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      <Component {...props} />
      // localStorage.getItem("user") ? (
      // localStorage.getItem("isLoggedIn")==="true" ? (
      //   <Component {...props} />
      // ) : (
      //   <Redirect to={{ pathname: "/auth", state: { from: props.location } }} />
      // )
    }
  />
);
